import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as L}from"../../icon-registry.js";const C=L("malaysia",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5L24 20.5L0 20.5L0 4.5Z"
                fill="white" />
            <path
                d="M23.9981 12.5L0.855469 12.5L0.855469 11.3568L23.9981 11.3568V12.5ZM23.9981 10.2144L0.855469 10.2144L0.855469 9.07119L23.9981 9.07119V10.2144ZM23.9981 7.92881L0.855469 7.92881L0.855469 6.78559L23.9981 6.78559V7.92881ZM23.9981 5.64322L0.855469 5.64322L0.855469 4.5L23.9981 4.5V5.64322Z"
                fill="#CC0000" />
            <path
                d="M0 4.5L12 4.5L12 14.2144L0 14.2144L0 4.5Z"
                fill="#000066" />
            <path
                d="M24 19.357L0 19.357L0 18.2138L24 18.2138V19.357ZM24 17.0714L0 17.0714L0 15.9282L24 15.9282V17.0714ZM24 14.7858L0 14.7858L0 13.6426L24 13.6426V14.7858Z"
                fill="#CC0000" />
            <path
                d="M7.17696 7.41916L7.3243 8.42711L7.89414 7.58309L7.58873 8.55493L8.46837 8.0412L7.77168 8.78472L8.78792 8.70374L7.83803 9.07111L8.78792 9.43848L7.77168 9.35749L8.46837 10.101L7.58873 9.58728L7.89414 10.5591L7.3243 9.7151L7.17696 10.7231L7.02962 9.7151L6.45978 10.5591L6.76519 9.58728L5.88555 10.101L6.58224 9.35749L5.56599 9.43848L6.51589 9.07111L5.56599 8.70374L6.58224 8.78472L5.88555 8.0412L6.76519 8.55493L6.45978 7.58309L7.02962 8.42711L7.17696 7.41916ZM6.35098 7.46063C5.4611 7.06594 4.41997 7.46697 4.02528 8.35686C3.63059 9.24674 4.03162 10.2879 4.92151 10.6826C5.3767 10.8845 5.8958 10.8845 6.35098 10.6826C5.4611 11.3207 4.22287 11.1173 3.58424 10.2274C2.9461 9.33749 3.14954 8.09926 4.03943 7.46063C4.73026 6.96495 5.66015 6.96495 6.35098 7.46063Z"
                fill="#FFCC00" />
        </svg>
    `),t=i`
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        static>
        <g clip-path="url(#clip0_19477_92920)">
            <rect
                y="0.5"
                width="24"
                height="24"
                rx="12"
                fill="#FF4E4E" />
            <path
                d="M-6 0.5L30 0.5L30 24.5L-6 24.5L-6 0.5Z"
                fill="white" />
            <path
                d="M29.999 12.5L-4.71484 12.5V10.7852L29.999 10.7852V12.5ZM29.999 9.07161L-4.71484 9.07161L-4.71484 7.35678L29.999 7.35678V9.07161ZM29.999 5.64322L-4.71484 5.64322V3.92839L29.999 3.92839V5.64322ZM29.999 2.21483L-4.71484 2.21483V0.5L29.999 0.5V2.21483Z"
                fill="#CC0000" />
            <path
                d="M-6 0.5L12 0.5L12 15.0716L-6 15.0716L-6 0.5Z"
                fill="#000066" />
            <path
                d="M30 22.7855L-6 22.7855L-6 21.0706L30 21.0706V22.7855ZM30 19.3571L-6 19.3571V17.6423L30 17.6423V19.3571ZM30 15.9287L-6 15.9287V14.2139L30 14.2139V15.9287Z"
                fill="#CC0000" />
            <path
                d="M8.20074 6.65755L8.42175 8.16947L9.27651 6.90344L8.81839 8.36121L10.1379 7.59061L9.09282 8.70589L10.6172 8.58441L9.19235 9.13547L10.6172 9.68652L9.09282 9.56504L10.1379 10.6803L8.81839 9.90973L9.27651 11.3675L8.42175 10.1015L8.20074 11.6134L7.97973 10.1015L7.12497 11.3675L7.58309 9.90973L6.26363 10.6803L7.30866 9.56504L5.78429 9.68652L7.20913 9.13547L5.78429 8.58441L7.30866 8.70589L6.26363 7.59061L7.58309 8.36121L7.12497 6.90344L7.97973 8.16947L8.20074 6.65755ZM6.96178 6.71975C5.62695 6.12771 4.06526 6.72926 3.47323 8.06409C2.88119 9.39892 3.48274 10.9606 4.81757 11.5526C5.50035 11.8556 6.279 11.8556 6.96178 11.5526C5.62695 12.5099 3.76961 12.2047 2.81167 10.8699C1.85445 9.53504 2.15962 7.67769 3.49445 6.71975C4.5307 5.97623 5.92553 5.97623 6.96178 6.71975Z"
                fill="#FFCC00" />
        </g>
        <defs>
            <clipPath id="clip0_19477_92920">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="white" />
            </clipPath>
        </defs>
    </svg>
`,d=L("malaysia_rounded",t),p=L("MYR",t);export{p as MYR,C as Malaysia,d as MalaysiaRounded};
